/* eslint-disable no-lonely-if */
const burgerMenuToggle = document.querySelector(".burger-menu-toggle");
const mobileMenu = document.querySelector(".mobile-menu");
const dropdownToggles = document.querySelectorAll(".mobile-dropdown-icon");
const burgerIcon = document.querySelector(".burger-icon");
const closeIcon = document.querySelector(".close-icon");

function toggleIcons() {
  burgerIcon.style.display =
    burgerIcon.style.display === "none" ? "block" : "none";
  closeIcon.style.display =
    closeIcon.style.display === "none" ? "block" : "none";
}

function toggleScrollLock() {
  if (mobileMenu.classList.contains("active")) {
    document.body.classList.add("no-scroll");
  } else {
    document.body.classList.remove("no-scroll");
  }
}

function closeAllOtherDropdowns(currentToggle = null) {
  dropdownToggles.forEach((toggle) => {
    if (currentToggle && toggle === currentToggle) {
      return;
    }

    const parentDropdown = toggle.closest(".mobile-dropdown");

    if (parentDropdown) {
      const dropdownMenu = parentDropdown.querySelector(".mobile-navigation-list-dropdown");

      if (dropdownMenu && dropdownMenu.classList.contains("active")) {
        parentDropdown.classList.remove("active");
        dropdownMenu.classList.remove("active");

        const downIcon = toggle.querySelector(".down-icon");
        const aboveIcon = toggle.querySelector(".above-icon");
        if (downIcon) downIcon.style.display = "block";
        if (aboveIcon) aboveIcon.style.display = "none";
      }
    }
  });
}

function closeMobileMenu() {
  if (mobileMenu.classList.contains("active")) {
    mobileMenu.classList.remove("active");
    toggleIcons();
    toggleScrollLock();

    if (window.$crisp) {
      window.$crisp.push(["do", "chat:show"]);
    }

    closeAllOtherDropdowns();
  }
}

burgerMenuToggle.addEventListener("click", () => {
  mobileMenu.classList.toggle("active");
  toggleIcons();
  toggleScrollLock();

  if (mobileMenu.classList.contains("active")) {
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:hide"]);
    }
  } else {
    if (window.$crisp) {
      window.$crisp.push(["do", "chat:show"]);
    }
  }
});

dropdownToggles.forEach((dropdownToggle) => {
  dropdownToggle.addEventListener("click", (e) => {
    e.stopPropagation();

    const parentDropdown = dropdownToggle.closest(".mobile-dropdown");
    if (parentDropdown) {
      const dropdownMenu = parentDropdown.querySelector(
        ".mobile-navigation-list-dropdown"
      );

      if (!dropdownMenu.classList.contains("active")) {
        closeAllOtherDropdowns(dropdownToggle);
      }

      parentDropdown.classList.toggle("active");
      dropdownMenu.classList.toggle("active");

      const downIcon = dropdownToggle.querySelector(".down-icon");
      const aboveIcon = dropdownToggle.querySelector(".above-icon");

      if (dropdownMenu.classList.contains("active")) {
        if (downIcon) downIcon.style.display = "none";
        if (aboveIcon) aboveIcon.style.display = "block";
      } else {
        if (downIcon) downIcon.style.display = "block";
        if (aboveIcon) aboveIcon.style.display = "none";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function (event) {
    if (!mobileMenu.contains(event.target) && !burgerMenuToggle.contains(event.target) && mobileMenu.classList.contains("active")) {
      closeMobileMenu();
    }
  });
});

let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    const desktopBreakpoint = 992;
    if (window.innerWidth >= desktopBreakpoint) {
      closeMobileMenu();
    }
  }, 150);
});
